import { z } from 'zod';

export const QUALITY_WINDOWS = [7, 30, 90] as const;
export type QualityWindow = (typeof QUALITY_WINDOWS)[number];
export const DEFAULT_WINDOW: QualityWindow = 30;
export const LONGEST_WINDOW: QualityWindow = 90;

const windowSchema = z.coerce.number().pipe(z.literal(QUALITY_WINDOWS));

export const TOTAL = 'total';

/** The page's view, kept in the URL: the window, one source, and the row whose detail is open. */
export const qualitySearchSchema = z.object({
  days: windowSchema.default(DEFAULT_WINDOW).catch(DEFAULT_WINDOW),
  source: z.uuid().optional().catch(undefined),
  detail: z
    .union([z.uuid(), z.literal(TOTAL)])
    .optional()
    .catch(undefined),
});

export type QualitySearch = z.output<typeof qualitySearchSchema>;
